// ワークフロー文書登録競合種別
export enum WorkflowDocumentConflictKinds {
  None = 0,
  SameStatus = 1, // 同一進捗
  DifferentStatus = 2 // 別進捗
}
